"use client";

import "./secondary-nav.scss";

const SecondaryNav = () => {
    return (
        <div className="secondary-nav">
            <div className="secondary-nav-container container px-4 mx-auto ">
                <ul className="secondary-nav-list flex items-center gap-3 sm:gap-6 hide-scrollbar overflow-x-auto">
                    <li className="secondary-nav-list-item">
                        <a className="flex-center text-center whitespace-nowrap" href="#flights">Flights</a>
                    </li>
                    <li className="secondary-nav-list-item">
                        <a className="flex-center text-center whitespace-nowrap" href="#itinerary">Itinerary</a>
                    </li>
                    <li className="secondary-nav-list-item">
                        <a className="flex-center text-center whitespace-nowrap" href="#hotels">Accommodations</a>
                    </li>
                    <li className="secondary-nav-list-item">
                        <a className="flex-center text-center whitespace-nowrap" href="#inclusion">Inclusion & Exclusion</a>
                    </li>
                    <li className="secondary-nav-list-item">
                        <a className="flex-center text-center whitespace-nowrap" href="#activities">Sightseeing / Activities</a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default SecondaryNav;
